exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrap-name[data-v-376af930]{display:flex;flex:1}.wrap-name[data-v-376af930],.wrap-name .intv-name[data-v-376af930]{white-space:nowrap;overflow:hidden}.wrap-name .intv-name[data-v-376af930]{text-overflow:ellipsis}.disabledBg[data-v-376af930]{background-color:#fff}", ""]);

// exports
